import { UrlObject } from '../../../../types/__codegen__/sanity/graphql';
import { URLS } from '../../../../models/url/constants';

type ContactLinks = ReadonlyArray<{
  title: string;
  link: Readonly<UrlObject>;
  subtitle?: JSX.Element;
  description?: JSX.Element;
}>;

const otherInsuranceContactLinks = (): ContactLinks => [
  {
    link: {
      name: 'Contact Us',
      url: `${URLS.SALES.LIFE_INSURANCE}/help`,
    },
    title: 'Life Insurance',
  },
  {
    link: {
      name: 'Contact Us',
      url: URLS.SALES.LIFE_INSURANCE_CONTACT_US,
    },
    title: 'Income protection',
  },
  {
    link: {
      name: 'Contact Us',
      url: URLS.SALES.TRAVEL_INSURANCE_CONTACT_US,
    },
    title: 'Travel Insurance',
  },
  {
    link: {
      name: 'Contact Us',
      url: URLS.SALES.CAR_INSURANCE_CONTACT_US,
    },
    title: 'Car Insurance',
  },
  {
    link: {
      name: 'Contact Us',
      url: URLS.SALES.HOME_INSURANCE_CONTACT_US,
    },
    title: 'Home Insurance',
  },
];

export default otherInsuranceContactLinks;
